import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';

import { Flex } from 'Components/Base';
import ConfirmationButton from 'Components/ConfirmationButton';

import BannerModal from '../Containers/BannerModal';

const ActionCell = ({ handleOnDelete, original }) => {
  const announcementId = original.id;

  return (
    <Flex>
      <Button.Group style={{ flex: 1 }}>
        <BannerModal
          isView
          announcementId={announcementId}
          trigger={
            <Button basic icon>
              <Icon name="eye" />
            </Button>
          }
        />
        <BannerModal
          isEdit
          announcementId={announcementId}
          trigger={
            <Button basic icon>
              <Icon name="edit" />
            </Button>
          }
        />
        <ConfirmationButton
          onConfirm={() => handleOnDelete(announcementId)}
          headerText={`Delete Banner?`}
          confirmText="Delete"
          contentText="This banner will be soft deleted from the system."
        >
          <Icon name="trash alternate" color="red" />
        </ConfirmationButton>
      </Button.Group>
    </Flex>
  );
};

ActionCell.propTypes = {
  original: PropTypes.object,
  handleOnDelete: PropTypes.func,
};

export default ActionCell;
